(function () {
    pagination(true);
})();

(function () {
    if (!document.body.classList.contains('post-template')) return;

    const cover = document.querySelector('.gh-cover');
    if (!cover) return;

    const image = cover.querySelector('.gh-cover-image');

    window.addEventListener('load', function () {
        cover.style.setProperty('--cover-height', image.clientWidth * image.naturalHeight / image.naturalWidth + 'px');
        cover.classList.remove('loading');
    });
})();

document.addEventListener('DOMContentLoaded', function(){
if(null === document.querySelector('.post-template #gh-head')){
    return false;
} else {
    let hero = document.documentElement;
    let header = document.querySelector('.post-template #gh-head');
    let progressBarContainer = document.createElement('div');
    let progressBarProgress = document.createElement('span');
    progressBarContainer.classList.add('progress-bar');
    progressBarContainer.style.backgroundColor = '#fff';
    progressBarContainer.style.height = '5px';
    progressBarContainer.style.position = 'fixed';
    progressBarContainer.style.top = '0';
    progressBarContainer.style.left = '0';
    progressBarContainer.style.width = '100vw';
    progressBarContainer.style.zIndex = '9999';
    progressBarProgress.classList.add('progress');
    progressBarProgress.style.height = '100%';
    progressBarProgress.style.width = '0';
    progressBarProgress.style.backgroundColor = '#000';
    progressBarProgress.style.display = 'block';
    // console.log( hero )
    // console.log( header )
    // console.log( progressBarContainer )
    // console.log( progressBarProgress )
    header.appendChild(progressBarContainer).
        appendChild(progressBarProgress);
        
    document.querySelector('.progress-bar .progress').style.width = ( hero.scrollTop / (hero.scrollHeight - hero.clientHeight) * 100 ) + '%';
    document.addEventListener('scroll', function(){
        let progressEl = document.querySelector('.progress-bar .progress');
        progressEl.style.width = ( hero.scrollTop / (hero.scrollHeight - hero.clientHeight) * 100 ) + '%';
    });
}
});